import React from "react";

interface UserMessageProps {
  content: string;
  attachedFile?: File | null; // Ajout du fichier attaché optionnel
}

const UserMessage: React.FC<UserMessageProps> = ({ content, attachedFile }) => {
  return (
    <>
      <div className="shrink-0 bg-gradient-to-b from-synkColor/15 to-slate-600 h-[1px] !mt-20 !-mb-6 flex w-full"></div>
      <div className="max-w-[400px] justify-center w-full flex-col items-end -pl-1 flex gap-3 mb-10">
        <div className="flex flex-col justify-start max-w-[300px] w-full">
          <div className="relative border border-gray-800 overflow-hidden bg-white rounded-2xl z-40 w-full p-3 shadow-[0px_2px_3px_-1px_rgba(0,0,0,0.1),_0px_1px_0px_0px_rgba(25,28,33,0.02),_0px_0px_0px_1px_rgba(25,28,33,0.08)]">
            <svg
              className="animate-spotlight pointer-events-none absolute opacity-100 -top-10 -left-20 rotate-6 z-[-1]"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 3787 2842"
              fill="none"
            >
              <g filter="url(#filter)">
                <ellipse
                  cx="1924.71"
                  cy="273.501"
                  rx="1924.71"
                  ry="273.501"
                  transform="matrix(-0.822377 -0.568943 -0.568943 0.822377 3631.88 2291.09)"
                  fill="white"
                  fillOpacity="0.21"
                ></ellipse>
              </g>
            </svg>
            <h1 className="text-base relative -tracking-tight gap-1 text-black">
              {content}
            </h1>
          </div>

          {/* Affichage du fichier attaché */}
          {attachedFile && (
            <div className="flex items-center gap-2 mt-2 px-3 py-2 bg-white rounded-xl border border-gray-600 max-w-[300px]">
              <svg
                className="w-4 h-4 text-black flex-shrink-0"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
                />
              </svg>
              <span className="text-sm text-black flex-1 truncate">
                {attachedFile.name}
              </span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default UserMessage;
